import { render } from "./RitzCarltonAssetType.vue?vue&type=template&id=2a5bf3ae"
import script from "./RitzCarltonAssetType.vue?vue&type=script&lang=js"
export * from "./RitzCarltonAssetType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__